import { useEffect, useState } from 'react'
import { firestore } from '../../firebase'
import { Table, Row, Skeleton, Typography } from 'antd'
import { CSVLink } from 'react-csv'
import moment from 'moment'

const { Title, Text } = Typography

const ListGrowth = () => {

  const [isFetching, setIsFetching] = useState(false)
  const [historyTableDma, setHistoryTableDma] = useState([])
  const [historyTableMmt, setHistoryTableMmt] = useState([])

  useEffect(() => {

    fetchHistory()

  }, [])

  const fetchHistory = async () => {

    setIsFetching(true)

    try {

      const res = await firestore.collection('listSize')
        .orderBy('created_at', 'desc')
        .limit(500)
        .get()

      if (res.empty) {
        setHistoryTableDma([])
        setHistoryTableMmt([])
        return
      }

      const allData = res.docs.map(x => ({
        ...x.data(),
        created_at: moment(x.data().created_at.toDate()).format('MM/DD/YY')
      }))

      // group by list
      const dma = allData.filter(x => x.list === 'DMA')
      const mmt = allData.filter(x => x.list === 'MMT')

      // group by date
      const groupByDate = group => {

        return group.reduce((acc, obj) => {

          const category = obj.created_at
          const existingArray = acc.find((arr) => arr[0].created_at === category)
        
          if (existingArray) {
            existingArray.push(obj)
          } else {
            acc.push([obj])
          }
        
          return acc
        }, [])
      }
      
      const dmaDated = groupByDate(dma)
      const mmtDate = groupByDate(mmt)

      // group create line item
      const createLineItem = group => {

        // Mapping of name suffixes to desired keys
        const nameMapping = {
          '1D': 'one',
          '2D': 'two',
          '3D': 'three',
          '4D': 'four',
          '14D': 'fourteen',
          '60D': 'sixty',
          '30D': 'thirty',
          '45D': 'fortyfive',
          '90D': 'ninety'
        }

        return group.map((x, i) => {

          // Initialize the output object with the shared created_at
          const output = { created_at: x[0].created_at, key: i }
          
          // Add size values with mapped keys
          x.forEach(item => {

            // Extract the number of days (e.g., '14D' from 'Active Users (14D)')
            const match = item.name.match(/\((\d+D)\)/)

            if (match) {
              const key = nameMapping[match[1]]
              if (key) output[key] = item.size
            }
          })
          
          return output
        })
      }

      const dmaComplete = createLineItem(dmaDated)
      const mmtComplete = createLineItem(mmtDate)
      
      // add to table
      setHistoryTableDma(dmaComplete)
      setHistoryTableMmt(mmtComplete)

    } catch (error) {

      console.error({error})

    } finally {

      // remove loading
      setIsFetching(false)
    }
  }

  const columns = [
    {
      width: 100,
      key: 'created_at',
      title: 'Date',
      dataIndex: 'created_at',
      defaultSortOrder: 'descend',
      sorter: (a, b) => moment(a.created_at).valueOf() - moment(b.created_at).valueOf(),
    }, {
      width: 100,
      key: 'one',
      title: '1D',
      dataIndex: 'one',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'two',
      title: '2D',
      dataIndex: 'two',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'three',
      title: '3D',
      dataIndex: 'three',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'four',
      title: '4D',
      dataIndex: 'four',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'fourteen',
      title: '14D',
      dataIndex: 'fourteen',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'thirty',
      title: '30D',
      dataIndex: 'thirty',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'fortyfive',
      title: '45D',
      dataIndex: 'fortyfive',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'sixty',
      title: '60D',
      dataIndex: 'sixty',
      render: num => num?.toLocaleString()
    }, {
      width: 100,
      key: 'ninety',
      title: '90D',
      dataIndex: 'ninety',
      render: num => num?.toLocaleString()
    }
  ]

  return (
    <>
      <Title level={2}>List Growth</Title>
      <Text type='secondary' style={{ marginBottom: '1em' }}>Growth of segments on Iterable lists</Text>

      {isFetching &&
        <Skeleton />
      }

      <Title level={4}>DMA</Title>
      <Row justify='space-between' align='middle'>
        <Table
          style={{ paddingTop: 20 }}
          loading={isFetching}
          columns={columns}
          dataSource={historyTableDma}
          scroll={{ x: 1000, y: 500 }}
          size='small'
          title={() => (
            <CSVLink
              filename={'ListGrowthDMA.csv'}
              data={historyTableDma}
              className='btn btn-primary'
            >
              Export to CSV
            </CSVLink>
          )}
        />
      </Row>

      <Title level={4}>MMT</Title>
      <Row justify='space-between' align='middle'>
        <Table
          style={{ paddingTop: 20 }}
          loading={isFetching}
          columns={columns}
          dataSource={historyTableMmt}
          scroll={{ x: 1000, y: 500 }}
          size='small'
          title={() => (
            <CSVLink
              filename={'ListGrowthMMT.csv'}
              data={historyTableMmt}
              className='btn btn-primary'
            >
              Export to CSV
            </CSVLink>
          )}
        />
      </Row>
    </>
  )
}

export default ListGrowth